import { isMobile } from "./exportFunc"
export default ()=>{

    const wrapper = document.querySelector('.partners-list');

    isMobile()&&wrapper? partHandle():false;

    function partHandle(){
        const elements = document.querySelectorAll('.partners-list__el');
        
        elements.forEach(el =>{
            const info = el.querySelector('.info-box');
            const img = el.querySelector('.img-box');
            const elementMargin = parseInt(getComputedStyle(el).marginBottom)
            const infoHeight = info.offsetHeight;
            const infoTop = parseInt(getComputedStyle(info).top);
            const overflow = infoHeight - infoTop;
            overflow>elementMargin? el.style.marginBottom = overflow + 'px': false
        })

    }
}